<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_share_project_title' | translate }}</h4>

  <p>{{ 'dialog_share_project_instructions' | translate }}</p>

  <form #form="ngForm">
    <div class="be-list">
      <div class="row">
        <div class="col">
          <mat-form-field>
            <mat-label color="accent">{{ 'dialog_share_project_filter_agencies' | translate }}</mat-label>
            <input matInput (keyup)="filterAgencies($event.target)" [(ngModel)]="agencies_filter_str" [ngModelOptions]="{ standalone: true }" />
          </mat-form-field>
        </div>
      </div>

      <div class="row agencies-list">
        <mat-selection-list #selectedAgencies [(ngModel)]="dialogData.selectedAgenciesIds" name="selectedAgencies" (ngModelChange)="onBeSelectionChange($event)">
          <mat-list-option *ngFor="let agency of agencies" [value]="agency.agencyId" [ngStyle]="{ display: agency.filtered ? 'none' : 'block' }">
            {{ agency.displayName }}
          </mat-list-option>
        </mat-selection-list>
      </div>
    </div>

    <div mat-dialog-actions>
      <button mat-button (click)="onClickBack()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button (click)="onClickShare()" color="accent" [disabled]="!(form.valid && canShare())">{{ 'dialog_share_project_btn_share' | translate }}</button>
    </div>
  </form>
</div>
